import {
    Formik,
    Form,
    Field,
    ErrorMessage
} from 'formik';
import { observer } from 'mobx-react-lite';
import { Box, Button, FormControl, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { adminCollectionKoUpdateSchema } from '../../../../../app/common/formValidations/validationSchemes';
import { useStore } from '../../../../../app/stores/store';
import CircularProgress from '@mui/material/CircularProgress';


interface Props {
    id: string;
    koNum: string;
    koUpdateHandler: (id: string, koNumber: string) => void;
}
interface updateFormValues {
    koId: string;
    koNumber: string;
}
const style = (isMobile: boolean) => {
    return ({
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? 400 : 360,
        bgcolor: '#DAE5F1',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    })
};
// const style = (isMobile: boolean) => {
//     return ({
//         position: 'absolute' as 'absolute',
//         top: '50%',
//         left: '50%',
//         transform: 'translate(-50%, -50%)',
//         width: isMobile ? 400 : 360,
//         bgcolor: '#bce2ca',
//         border: '2px solid #000',
//         boxShadow: 24,
//         p: 4,
//     })
// };
export default observer(function KoUpdateForm({ id, koNum, koUpdateHandler }: Props) {

    const { modalStore, adminCollectionStore } = useStore();
    const { closeModal } = modalStore;
    const { loadingKoNumberUpdate } = adminCollectionStore;

    const matches = useMediaQuery('(min-width:900px)');

    const initialValues: updateFormValues = {
        koId: id,
        koNumber: koNum?.toUpperCase()?.trim(),
    };

    return (
        <Box sx={style(matches)}>
            <Typography variant='h5' textAlign='center'>Update Ko Number</Typography>
            <Formik
                initialValues={initialValues}
                validationSchema={adminCollectionKoUpdateSchema}
                onSubmit={(values, { setSubmitting }) => {
                    koUpdateHandler(values.koId, values.koNumber as string);
                    setSubmitting(false);
                   
                }}
            >
                {({ values,
                    handleChange,
                    handleBlur,
                    isSubmitting, }) => {
                    return (
                        <Form className="w100" autoComplete="off">
                            <Stack direction='column' spacing={2} m={2} alignItems='center'>
                                <FormControl sx={{ width: 300 }}>
                                    <Field
                                        type="text"
                                        component={TextField}
                                        id="koNumber"
                                        name="koNumber"
                                        placeholder="KO-99999999"
                                        margin="normal"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.koNumber}
                                        variant="outlined"
                                    />
                                    <ErrorMessage name="koNumber" component="span" />
                                </FormControl>
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    pt={2}
                                >
                                    {loadingKoNumberUpdate ? <CircularProgress size='1.2em' /> :
                                        <Button size="medium" type='submit' variant="contained" color="primary" endIcon={<CloudUploadIcon />}>Update</Button>
                                    }

                                    {!loadingKoNumberUpdate &&
                                        <Button size={matches ? "medium" : "small"} variant="contained"
                                            onClick={() => closeModal()}>Cancel</Button>
                                    }
                                </Stack>
                            </Stack>
                        </Form>
                    );
                }}
            </Formik>
        </Box>

    );
});